import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { FaRoute } from "react-icons/fa";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";

import { useTheme } from "../../contexts/ThemeContext";
import { routingService } from "../../Services/routing.service";
import RouteDetailsModal from "./components/RouteDetailsModal";
import Spinner from "../Components/Spinner";
import { appendTravelModeToGoogleMapsUrl } from "./utils/googleMaps";

export default function RoutesList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  // Antes guardava só o id e o modal rebuscava via GET /routes/{id}.
  // Esse endpoint não existe mais (confirmado com o backend), então
  // agora guardamos a rota inteira, já disponível na listagem (GET /routes).
  const [selectedRoute, setSelectedRoute] = useState(null);

  useEffect(() => {
    dispatch({ type: "title", value: t("ROUTING.TITLE") });
  }, [dispatch, t]);

  useEffect(() => {
    loadRoutes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadRoutes = () => {
    setLoading(true);
    routingService
      .fetchAllRoutes()
      .then((res) => setRoutes(Array.isArray(res) ? res : []))
      .finally(() => setLoading(false));
  };

  const goToRoutingScreen = () => navigate("/routing/new");

  const openMap = (link, vehicleType) => {
    if (!link) return;
    window.open(appendTravelModeToGoogleMapsUrl(link, vehicleType), "_blank", "noopener,noreferrer");
  };

  const gridData = routes.map((r) => ({
    ...r,
    routeId: r.routeId ?? r.RouteId ?? r.id,
    originName: r.originName ?? r.OriginName,
    destinationName: r.destinationName ?? r.DestinationName,
    mapLink: r.mapLink ?? r.MapLink,
    vehicleType: r.vehicleType ?? r.VehicleType,
  }));

  const actionTemplate = (props) => (
    <div className="d-flex gap-2">
      <button
        className="btn btn-sm btn-outline-primary"
        style={isDark ? { color: "#fff", borderColor: "#fff" } : {}}
        onClick={() => setSelectedRoute(props)}
      >
        Ver detalhes
      </button>
      <button
        className="btn btn-sm btn-outline-secondary"
        style={isDark ? { color: "#fff", borderColor: "#fff" } : {}}
        onClick={() => openMap(props.mapLink, props.vehicleType)}
        disabled={!props.mapLink}
        title={!props.mapLink ? "Link não disponível para esta rota" : ""}
      >
        Ver Mapa
      </button>
    </div>
  );

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Rotas salvas</h5>
        <button
          type="button"
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={goToRoutingScreen}
          style={{ fontSize: 13 }}
        >
          <FaRoute size={13} /> Roteirizar
        </button>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner />
        </div>
      ) : routes.length === 0 ? (
        <div className="text-center text-secondary my-5" style={{ fontSize: 13 }}>
          Nenhuma rota salva ainda.
        </div>
      ) : (
        <div className="card grid-card" style={{ marginTop: 8 }}>
          <GridComponent
            dataSource={gridData}
            allowFiltering={false}
            rowHeight={30}
            height="auto"
            locale="pt-BR"
          >
            <ColumnsDirective>
              <ColumnDirective field="originName" headerText="Origem" width="200" />
              <ColumnDirective field="destinationName" headerText="Destino" width="200" />
              <ColumnDirective headerText="" width="280" template={actionTemplate} />
            </ColumnsDirective>
          </GridComponent>
        </div>
      )}

      <RouteDetailsModal
        show={!!selectedRoute}
        route={selectedRoute}
        handleClose={() => setSelectedRoute(null)}
      />
    </div>
  );
}
